import styled from 'styled-components';
import PropTypes from 'prop-types';
import { appTheme } from '../../theme';

const PageTitle = styled.h2`
  color: ${props => props.color || appTheme.system.active};
`;

PageTitle.propTypes = {
  color: PropTypes.string,
};

export default PageTitle;



// WEBPACK FOOTER //
// ./src/modules/common/PageTitle.js